<template lang="html">
  <div class="float-menu asset-menu">
    <div class="image-container bg_transparent image-btn" ref="btn">
      <div class="image" :style="{backgroundImage: `url(${assets[modelValue]})`}"></div>
    </div>
    <div v-if="isOpen" class="float-menu-inner images">
      <div class="assets">
        <div class="image-container bg_transparent" :class="{'selected': !modelValue}" @click="$emit('update:modelValue', '')">
          <div class="image"></div>
        </div>
        <div v-for="(dataUrl, name) in assets" :key="name" :title="name" class="image-container bg_transparent" :class="{'selected': modelValue === name}" @click="$emit('update:modelValue', name)">
          <div class="image" :style="{backgroundImage: `url(${dataUrl})`}"></div>
        </div>
      </div>
    </div>
    <div v-if="isMouseOver && !isOpen && assets[modelValue]" class="float-menu-inner hover">
      <div class="image-container bg_transparent">
        <img class="image" :src="assets[modelValue]" />
      </div>
    </div>
  </div>
</template>

<script>
import GameStudio from '@/assets/js/GameStudio.js'

export default {
	props: ['modelValue'],
	emits: ['update:modelValue'],
  data() {
    return {
      assets: GameStudio.getFilesWithExtensions(['.png', '.jpg']).toNameData(),
      isOpen: false,
      clickBinded: null,
      isMouseOver: false,
      hoverBinded: null
    };
  },
	methods: {
    clickHandler(event) {
      this.isOpen = event.target.closest('.image-btn') === this.$refs.btn;
    },
    hoverHandler(event) {
      this.isMouseOver = event.target.closest('.image-btn') === this.$refs.btn;
    }
	},
  mounted() {
    this.clickBinded = this.clickHandler.bind(this);
    this.hoverBinded = this.hoverHandler.bind(this);
    document.addEventListener('click', this.clickBinded, true);
    document.addEventListener('mousemove', this.hoverHandler, true);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickBinded, true);
    document.removeEventListener('mousemove', this.hoverHandler, true);
  }
}
</script>

<style lang="css" scoped>
.asset-menu .float-menu-inner.images {
  display: block;
  width: 236px;
  height: 300px;
  padding: 10px;
  overflow: auto;
}
.asset-menu .assets {
  display: flex;
  flex-wrap: wrap;
}
.asset-menu .image-container {
  border: 2px solid rgba(255, 255, 255, 0.3);
	display: inline-block;
	opacity: 0.8;
	image-rendering: pixelated;
}
.asset-menu .image-container.selected {
	border-color: #ffa800;
	opacity: 1;
}
.asset-menu .image-btn {
  display: block;
  opacity: 1;
  border: none;
  margin: 1px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3);
}
.asset-menu .image {
  width: 48px;
  height: 48px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.asset-menu .image-btn .image {
  width: 64px;
  height: 48px;
}
.float-menu:hover .float-menu-inner.hover {
  display: block;
}
.float-menu-inner.hover .image {
  display: block;
  width: auto;
  height: auto;
  max-width: 256px;
  max-height: 256px;
}
</style>
